import React, { Component } from 'react';
import {initFirestorter, Collection} from 'firestorter';
import { inject, observer } from 'mobx-react';
import { compose } from 'recompose';
import {withAuthorization} from './utils/auth';
import {doLogout} from './firebase/firebase';
import {
  BrowserRouter as Router,
  Route,
  Link,
  NavLink,
  Switch,
  withRouter
} from 'react-router-dom';
import * as routes from './routes';
import Overview from './Overview';
import Users from './Users';
import UserDetails from './UserDetails';
import Requests from './Requests';
import RequestDetails from './RequestDetails';
import Contracts from './Contracts';
import ContractDetails from './ContractDetails';

import Settings from './Settings';

import './App.css';
import { Layout, Menu, Icon } from 'antd';
const { Header, Sider, Content } = Layout;

@observer
class Dash extends Component {
  state = {
    collapsed: (localStorage.getItem('navigationIsCollapsed') == 'true')? true : false,
  };
  toggle = () => {
    localStorage.setItem('navigationIsCollapsed', !this.state.collapsed);
    this.setState({
      collapsed: !this.state.collapsed
    });
  };
  componentDidMount() {
      const { userStore } = this.props;
      console.log('userStore', userStore);
    }

  render() {
    const { users } = this.props.userStore;
    return (
      <Layout className="layout">
        <Sider
          trigger={null}
          collapsible
          collapsed={this.state.collapsed}
        >
          <div className="logoContainer">
            <div className="logo" style={this.state.collapsed ? {backgroundSize: 'cover', marginLeft: 'auto', marginRight: 'auto', backgroundPositionX: '0px', 'width': '24px'} : {backgroundSize: 'contain', backgroundPosition: 'center'}}/>
          </div>
          <Menu theme="dark" selectable={false} mode="inline">
            <Menu.Item key={routes.OVERVIEW}>
              <NavLink exact strict to={routes.OVERVIEW} activeClassName="ant-menu-item-selected"><Icon type="appstore-o" /><span>Dashboard</span></NavLink>
            </Menu.Item>
            <Menu.Item key="2">
              <NavLink to={routes.USERS} activeClassName="ant-menu-item-selected"><Icon type="user" /><span>Utilisateurs</span></NavLink>
            </Menu.Item>
            <Menu.Item key="3">
              <NavLink exact to={routes.REQUESTS} activeClassName="ant-menu-item-selected"><Icon type="profile"/><span>Demandes</span></NavLink>
            </Menu.Item>
            <Menu.Item key="4">
              <NavLink exact to={routes.CONTRACTS} activeClassName="ant-menu-item-selected"><Icon type="calendar"/><span>Contrats</span></NavLink>
            </Menu.Item>
            <Menu.Item key="5">
              <NavLink exact to={routes.SETTINGS} activeClassName="ant-menu-item-selected"><Icon type="setting"/><span>Configuration</span></NavLink>
            </Menu.Item>
            <Menu.Item key="6">
              <a onClick={doLogout}>
              <Icon type="poweroff" />
              <span>Déconnexion</span>
              </a>
            </Menu.Item>
          </Menu>
        </Sider>
        <Layout>
          <Header style={{ background: '#fff', padding: 0 }}>
            <Icon
              className="trigger"
              type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
              onClick={this.toggle}
            />
          </Header>
          <Content style={{ margin: '24px 16px', padding: 24, background: '#fff', minHeight: 280 }}>
            <Route exact path={routes.OVERVIEW} component={Overview} />
            <Route exact strict path={routes.USERS} component={Users}/>
            <Route exact strict name="User Details" path={routes.USERDETAILS} component={UserDetails}/>
            <Route exact path={routes.REQUESTS} component={Requests} {...this.props}/>
            <Route exact strict name="Request Details" path={routes.REQUESTDETAILS} component={RequestDetails}/>
            <Route exact path={routes.CONTRACTS} component={() => <Contracts/> } />
            <Route exact strict name="Contract Details" path={routes.CONTRACTDETAILS} component={ContractDetails}/>
            <Route exact strict path={routes.SETTINGS} component={Settings}/>
          </Content>
        </Layout>
      </Layout>
    );
  }
}

const authCondition = (authUser) => !!authUser;

export default compose(
  withAuthorization(authCondition),
  inject('userStore'),
  withRouter,
  observer
)(Dash);



// WEBPACK FOOTER //
// ./src/dashboard.js